var map = {
	"./bbb/marinemax-mareq-bbb_lda.json": 6334,
	"./bbb/trynewleaf-bbb_lda.json": 4847,
	"./bestcompany/costco-optical-bestcompany_lda.json": 3414,
	"./consumeraffairs/cohen-fashion-consumeraffairs_lda.json": 8051,
	"./pissedconsumer/westmarine-mareq-pissedconsumer_lda.json": 3070,
	"./trustpilot/eye-care-partners-trustpilot_lda.json": 6851
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7870;